export const config = {
    apiEndpoint: "https://sr-php.thesellerapp.com/public/index.php/api",
    // apiEndpoint: "https://preprodshikharapp.hulsecure.in/public/index.php/api",
    // nodeapiEndpoint:"https://sr-php.thesellerapp.com/public/index.php/api",
    nodeapiEndpoint: "https://sr.thesellerapp.com/igm",
    // nodeapiEndpoint: "https://preprod.xpressbaazaar.com/igm",
    baseNodeapiUrl: "https://sr.thesellerapp.com",
    // baseNodeapiUrl: "https://preprod.xpressbaazaar.com",
    // awsKeyId: "AKIAYJUL5VJOBYQMJDT7",
    // awsSecretKey: "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"
    awsKeyId: process.env.REACT_APP_ACCESS_KEY_ID,
    awsSecretKey: process.env.REACT_APP_SECRET_ACCESS_KEY,
    awsRegion: process.env.REACT_APP_AWS_REGION,
    awsBucket: process.env.REACT_APP_AWS_BUCKET,
}
export function baseUrlDefiner() {
    const fullUrl = window.location.host;
    const port = window.location.port || "3000";
    let apiEndpoint = "seller_register";

    switch (fullUrl) {
        case "multipleselleradmin.thesellerapp.com":
            apiEndpoint = "https://ideamaster.thesellerapp.com/public/index.php/api";
            break;
        case "preprodadmin.xpressbaazaar.com":
            apiEndpoint = "https://preprodshikharapp.hulsecure.in/public/index.php/api";

            break;
        case "wacpreprod-admin.thesellerapp.com":
            apiEndpoint = "https://wac-preprod.hulsecure.in/public/index.php/api";

            break;
        case "multisellersadmin.thesellerapp.com":
            apiEndpoint = "https://multisellersphp.thesellerapp.com/public/index.php/api";
            break;
        default:
            // apiEndpoint = "https://preprodshikharapp.hulsecure.in/public/index.php/api";
            apiEndpoint = "https://sr-php.thesellerapp.com/public/index.php/api";
            break;
    }
    return apiEndpoint;
}

export function NodebaseUrlDefiner() {
    const fullUrl = window.location.host;
    const port = window.location.port || "3000";
    let baseNodeapiUrl = "";
    switch (fullUrl) {
        case "multipleselleradmin.thesellerapp.com":
            baseNodeapiUrl = "https://ondc.theideamasters.com"
            break;
        case "preprodadmin.xpressbaazaar.com":
            baseNodeapiUrl = "https://preprod.xpressbaazaar.com"
            break;
        case "wacpreprod-admin.thesellerapp.com":
            baseNodeapiUrl = "https://preprod.xpressbaazaar.com"
            break;
        case "preprodadmin.msmekidukan.com":
            baseNodeapiUrl = "https://sr.thesellerapp.com"
            break;
        default:
            baseNodeapiUrl = "https://sr.thesellerapp.com"

            break;
    }
    return baseNodeapiUrl;
}